import React, { useRef } from 'react'
import styled from 'styled-components'
import ReactDOM from 'react-dom'

import { useOuterClickNotifier, useHotkey } from 'hooks/outerClick'

const Modal = ({ isOpened, setIsOpened, children, portalRef = document.body, noActions }) => {
  const innerModalRef = useRef(null)

  useOuterClickNotifier(() => !noActions && isOpened && setIsOpened(false), innerModalRef)
  useHotkey('Escape', () => !noActions && isOpened && setIsOpened(false))

  return (
    isOpened &&
    ReactDOM.createPortal(
      <ModalContainer active={isOpened}>
        <Container ref={innerModalRef}>{children}</Container>
      </ModalContainer>,
      portalRef,
    )
  )
}

const Container = styled.div`
  justify-content: center;
  max-width: 1920px;
  margin: 0;
  width: 100%;
  display: flex;
`

const ModalContainer = styled.div`
  left: 0;
  top: 0;
  position: fixed;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: hidden;
  z-index: 30;
  opacity: ${({ active }) => (active ? '1' : '0')};
  visibility: ${({ active }) => (active ? 'visible' : 'hidden')};
  pointer-events: ${({ active }) => (active ? 'auto' : 'none')};
  transition: all 0.3s ease-out;

  @media (max-width: 480px) {
    padding-top: 100px;
    padding-bottom: 50px;
    overflow-y: scroll;
  }
`

export default Modal
